import { useState } from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
            navigate(dir);
        };
    
  return (
    <ThemeProvider theme={rose}>
          <Window resizable className='window' style={{ display: 'block',width: '60%', height: '75vh' }}>
            <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>Coming Soon</span>
              <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/')}>
              <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
              </Button>
            </WindowHeader>

            <WindowContent style={{ height: 'calc(100% - 33px)', width:'100%', padding: 0 }}>
              <Frame variant='well' className='footer' style={{ height: '100%', margin: 0 }}>
                <ScrollView style={{ height: '100%' }}>
                  <div style={{ padding: '1rem' }}>
                    <h1>This part of my website is still under construction :(</h1>
                    <p style={{ color: "#c43961" }}>
                      Check back here to see when it's finished
                    </p>
                  </div>
                </ScrollView>
              </Frame>
            </WindowContent>

          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
